import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  localDomains: [],
  searchQuery: '',
  localDomainToUpdate: {},
  loading: false,
  error: false,
};

const localDomainsSlice = createSlice({
  name: 'localDomains',
  initialState,
  reducers: {
    setSearchQuery(state, action) {
      state.searchQuery = action.payload;
    },
    localDomainAdded(state, action) {
      state.localDomains.push(action.payload);
    },
    getLocalDomains(state) {
      state.loading = true;
    },
    getLocalDomainsSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.localDomains = action.payload;
    },
    getLocalDomainsFailure(state, action) {
      state.loading = false;
      state.error = true;
      state.localDomains = action.payload;
    },
    deletedLocalDomain(state, action) {
      state.localDomains = state.localDomains.filter(
        (domain) => domain.id !== action.payload
      );
    },
    updatedLocalDomain(state, action) {
      state.localDomainToUpdate = action.payload;
    },
  },
});

export const {
  setSearchQuery,
  localDomainAdded,
  getLocalDomains,
  getLocalDomainsSuccess,
  getLocalDomainsFailure,
  deletedLocalDomain,
  updatedLocalDomain,
} = localDomainsSlice.actions;
export default localDomainsSlice.reducer;
